module.exports = __webpack_public_path__ + "static/media/logoWellcare.00c79de2.png";